import {createStateMaker} from '@shared/helpers/object'

import {ABTestState} from '../interfaces'

export const getInitialState = (): ABTestState => ({
    naverId: null,
    variantMap: {},
})

export const makeMock = createStateMaker<ABTestState>(getInitialState)
